import React, { useContext } from 'react';
import { TableContainer, Table } from '@chakra-ui/react';
import { localise } from '../../../services/lang/lang';
import useStyling from '../../../hooks/useStyling';
import ResultTableBody from '../ResultTableBody/ResultTableBody';
import Pagination from '../Pagination/Pagination';
import SortableTableHead from '../SortableTableHead/SortableTableHead';
import { ActiveUsersTableContext } from '../../pages/upgrade/TeamManagement/ActiveUsersTableContext';
const headers = [
    {
        title: localise('NAME'),
        key: 'name',
        sortField: 'full_name',
    },
    {
        title: localise('EMAIL'),
        key: 'email',
        sortField: 'email',
    },
    {
        title: localise('ROLE'),
        key: 'role',
    },
    {
        title: localise('PERMISSIONS'),
        key: 'permissions',
    },
];
const UsersTable = ({ pagination, onSort, currentSortOptions, isFetching, children, }) => {
    const styling = useStyling();
    const { canPerformActions } = useContext(ActiveUsersTableContext);
    return (React.createElement(TableContainer, { sx: styling.tableContainer.roundedWithPadding },
        React.createElement(Table, { cursor: "default", variant: "rounded" },
            React.createElement(SortableTableHead, { currentSortOptions: currentSortOptions, onSort: onSort, headers: headers, leftPadding: canPerformActions ? 1 : 0 }),
            React.createElement(ResultTableBody, { isFetching: isFetching, colCount: 5, sx: styling.tableBody.noHover }, children)),
        pagination && React.createElement(Pagination, { meta: pagination })));
};
export default UsersTable;
